import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { Link } from 'react-router-dom';
import { useSelector } from "react-redux";

const FooterMobile = (props) => {

	const { selectedItem } = props.data;
	const { totalPrice } = useSelector(state => state.shoppingCart);

	const toPersianDigits = (num) => {
        return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
    };

    return (

        <div className="w-full bg-neutral-000 z-3 fixed left-0 bottom-0 shadow-1-top" id="base_layout_mobile_footer" width="375" height={props.data.showCart ? '128.3125' : '54.6875'} >

        	{props.data.showCart ?
        	<div>
				<div className="px-4 py-3 bg-neutral-000 w-full">
					<div className="flex flex-row justify-between items-start">
						<div className="hidden lg:block">
							<button className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-1 styles_btn--large__1Muai styles_btn--outlined__saFC3 styles_btn--primary__y0GEv rounded-medium">
								<div className="flex items-center justify-center relative grow">بازگشت
								</div>
							</button>
						</div>
						<div className="w-full lg:w-unset">
							<div className="flex flex-row justify-between items-center">
								<div className="w-6/12 lg:w-unset styles_fixedCTA__ButtonBox__XKO9J">
									<Link to="/checkout/shipping/" className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-1 styles_btn--large__1Muai styles_btn--primary__y0GEv rounded-medium w-full" data-cro-id="cart-continue-shopping" >
										<div className="flex items-center justify-center relative grow">تایید و تکمیل سفارش
										</div>
									</Link>
								</div>
								<div className="flex flex-col justify-between items-end mr-4 lg:mr-0 lg:ml-4 styles_fixedCTA__titleBox__LlT6U">
									<p className="text-caption text-neutral-500 ">جمع سبد خرید
									</p>
									<div className="flex justify-start items-center">
										<div className="ml-1 text-subtitle-strong text-neutral-800">{toPersianDigits((totalPrice / 10).toLocaleString())}
										</div>
										<div className="w-4 h-4 text-neutral-800">
											<div className="flex">
												<svg style={{width: '16px', height: '16px', fill: 'var(--undefined)'}}>
													<use xlinkHref="#toman"></use>
												</svg>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			:''}

			<div>
				<div className="styles-container">
					<div className="flex border-complete-t w-full bg-neutral-000 z-5">
						<Link className="flex flex-col lg:flex-row items-center flex-1 py-1 styles-navItem" to="/">
							<div className="flex">
								<HomeOutlinedIcon sx={{fontSize: '24px', fill: `${selectedItem === "home" ? 'var(--color-icon-high-emphasis)': 'var(--color-icon-low-emphasis)'}`}} />
							</div>
							<p className={`text-caption ${selectedItem === "home" ? "text-neutral-900 text-caption-strong" : "text-neutral-500"}`}>خانه</p>
						</Link>
						<Link className="flex flex-col lg:flex-row items-center flex-1 py-1 styles-navItem" to="/categories/">
							<div className="flex">
								<CategoryOutlinedIcon sx={{fontSize: '24px', fill: `${selectedItem === "categories" ? 'var(--color-icon-high-emphasis)': 'var(--color-icon-low-emphasis)'}`}} />
							</div>
							<p className={`text-caption ${selectedItem === "categories" ? "text-neutral-900 text-caption-strong" : "text-neutral-500"}`}>دسته‌بندی</p>
						</Link>
						<Link className="flex flex-col lg:flex-row items-center flex-1 py-1 styles-navItem" to="/checkout/cart/">
							<div className="relative flex flex-col">
								<a className="relative inline-flex pr-2 pl-0 lg:p-2 bg-neutral-000 rounded py-0" data-cro-id="header-cart" href="/checkout/cart/">
									<div className="flex">
										<ShoppingCartOutlinedIcon sx={{fontSize: '24px', fill: `${selectedItem === "cart" ? 'var(--color-icon-high-emphasis)': 'var(--color-icon-low-emphasis)'}`}} />
									</div>
								</a>
							</div>
							<p className={`text-caption ${selectedItem === "cart" ? "text-neutral-900 text-caption-strong" : "text-neutral-500"}`}>سبد خرید</p>
						</Link>
						<Link className="flex flex-col lg:flex-row items-center flex-1 py-1 styles-navItem" to="/profile/">
							<div className="relative cursor-pointer">
								<div className="styles_BaseLayoutMiniProfile__button__DHUHQ relative  flex rounded p-0" data-cro-id="HP-profile-header">
									<div>
										<div className="flex">
											<PersonOutlineIcon sx={{fontSize: '24px', fill: `${selectedItem === "profile" ? 'var(--color-icon-high-emphasis)': 'var(--color-icon-low-emphasis)'}`}} />
										</div>
									</div>
								</div>
							</div>
							<p className={`text-caption ${selectedItem === "profile" ? "text-neutral-900 text-caption-strong" : "text-neutral-500"}`}>کوچیی من</p>
						</Link>
					</div>
				</div>
			</div>
		</div>

    );
}

export default FooterMobile;
